import type { DomainSpecificConfig } from '../types';

const config: DomainSpecificConfig = {
  domains: [
    /magicschoolai-git-.*\.vercel\.app/,
    /teacher-.*\.vercel\.app/,
    /teacher-.*-magicschoolai-vercel-app\.translate\.goog/,
    /login-.*\.vercel\.app/,
    /login-.*-magicschoolai-vercel-app\.translate\.goog/,
    /^(app|login)\..*\.magicschooldev\.com$/,
    /^(app|login)\.magicschooldev\.com$/,
  ],
  domainType: 'school',
};

export default config;
